import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
const FIRSTTIME = 'firstTime';
import { environment } from '@env/environment';
import { apiConfig } from '@app/app-config';
import { CustomAuthenticationService } from '@app/auth/services/custom-authentication.service';
import { TIME_TO_EXPIRE_SESSION } from '@app/custom-home/custom-home.component';
import * as moment from 'moment';


@Injectable({
  providedIn: 'root'
})
export class SessionService {

  expireTime: number = TIME_TO_EXPIRE_SESSION / 60 / 1000;

  constructor(private msalService: MsalService, private customAuthenticationService: CustomAuthenticationService,) { }

  isFirstTime(): boolean {
    if (sessionStorage.getItem(FIRSTTIME)) {
      return false;
    } else {
      sessionStorage.setItem(FIRSTTIME, 'false');
      return true;
    }
  }

  clearFirstTime() {
    sessionStorage.removeItem(FIRSTTIME);
  }

  getExpireDateTimeAsDate(dateString: string) {
    if (!dateString) {
      dateString = new Date().toISOString();
    }
    return new Date(dateString);
  }

  getExpireDateTimeAsString(date: Date): string {
    return date.toISOString();
  }


  getDifferenceInMinutes(date1, date2) {
    let dateNow = moment(date2).subtract('15', 'minutes');
    let dateBefore = moment(date1);
    if (dateNow > dateBefore) {
      return true;
    } else {
      return false;
    }
  }

  isExpiredDateTime(oldDate: Date): boolean {
    let spentMinutes = this.getDifferenceInMinutes(oldDate, new Date());
    if (spentMinutes) {
      return true;
    }
    return false;
  }

  async logout() {
    let loginDisplay = this.msalService.instance.getAllAccounts()[0];
    this.clearFirstTime();
    await this.msalService
      .acquireTokenSilent({
        account: loginDisplay,
        redirectUri: environment.msalUrl,
        scopes: apiConfig.scopes,
      }).toPromise()
      .then(async authResult => {
        await this.msalService.logout({ idTokenHint: `${authResult.idToken}` }).toPromise();
      }).finally(() => {
        sessionStorage.clear();
      });
  }
}
